<template>
  <div class="chat-wrapper">
    <div class="message-list-wrapper" id="message-list-wrapper">
      <div class="message-list" id="message-list">
        <div class="message" :class="m.name == $store.state.auth.user.fullName ? 'is_mine' : ' '" v-if="messages"  v-for="m in messages" :key="m._id">
          <div class="message-wrapper">
            <div class="message-name">{{m.name}}</div>
            <div class="message-text">{{m.text}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="input-wrapper">
      <Input class="message-input" v-model="message" clearable placeholder="Type your message" @on-enter="sendMessage"/>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions} from 'vuex'
  import $config from '@/config'

  export default {
    data(){
      return{
        isReady: false,
        message: null
      }
    },
    computed:{
      ...mapGetters('webcast', {
        webcast: 'getCopy'
      }),
      ...mapGetters('teamchat', {
        getMessagesDataInStore: 'find'
      }),
      messages(){
        this.scrollToListBottom ()
        return this.getMessagesDataInStore({
          query:{
            webcastId: this.webcast._id,
            $sort:{
              createdAt: 1
            }
          }
        }).data
      }
    },
    methods:{
      ...mapActions('teamchat', {
        findMessages: 'find',
        createMessage: 'create',
        patchMessage: 'patch'
      }),
      sendMessage(){
        this.createMessage({
          webcastId: this.webcast._id,
          text:this.message,
          name: this.$store.state.auth.user.fullName
        }).then(()=>{
          this.message="";
        })
      },
      scrollToListBottom () {
        setTimeout(()=>{
          let listEl = document.getElementById('message-list-wrapper');
          listEl.scrollTop = listEl.scrollHeight;
        },200)

      },
    },
    created() {
      this.findMessages({query:{webcastId: this.webcast._id}}).then((messages)=>{
        this.$data.isReady = true;
      });
    }
  }
</script>
<style lang="scss">
  .chat-wrapper{
    height: calc(100% - 4px);
    background-color:#f5f5f5;
    .message-list-wrapper{
      height:calc(100% - 50px);
      overflow-y:scroll;
    }
    .message-list{
      display:inline-block;
      padding:10px;
      font-size:12px;
      width: 100%;
      .message{
        position: relative;
        margin-top: 8px;
        display:inline-block;
        width:100%;
        &-wrapper{
          padding: 8px 12px;
          width: fit-content;
          max-width: 80%;
          background-color: #fff;
          border-radius: 8px;
          -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
          box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
        }
        &-name{
          font-weight:bold;
        }
        &-text{
          line-height:1.4;
        }
        &.is_mine .message-wrapper{
          background-color:#2d8cf0;
          color:#fff;
          float:right;
        }
      }
    }
  }
  .input-wrapper{
    position: relative;
    width:100%;
    bottom:0;
    background-color:#fff;
    padding:8px;
    input{
      border:none;
    }
  }
</style>
